import React, { useState, useEffect, useRef } from "react";
import "./GroupPreviewWorkshop.scss";
import _ from "lodash";
import moment from "moment";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const GroupPreviewWorkshop = ({
  banner,
  thumbnail,
  participantChips,
  chips,
  currentLanguage,
  sessionURL,
  status,
  workshopName,
  sessionDate,
  prerequisites,
  resource,
  sessionTime,
  description,
  formikRef,
  trainersList,
  membersList,
  languageOptions,
  timezoneOptions,
}) => {

  const { t } = useTranslation();
  const { values } = useFormikContext()

  const languageListRes = useSelector((state) => state.user.getLanguagesList);

  const [sessionData, setSessionData] = useState({})
  const [languageList, setLanguagesList] = useState([])

  useEffect(() => {
    // Check if sessionArray is not empty
    // Sort sessionArray by sessionStartDate and set sessionData
    if (!_.isEmpty(values.sessionArray)) {
      const sortedSessionArray = _.sortBy(values.sessionArray, 'sessionStartDateTime')
      setSessionData(sortedSessionArray[0])
    }
  }, [values])

  useEffect(() => {
    console.log("languages-", languageListRes);
    if (!_.isEmpty(languageListRes)) {
      if (languageListRes?.status === "success") {
        // setLanguageSet(languageListRes?.payload?.payload);
        let list = languageListRes?.payload?.payload?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setLanguagesList(list);
      } else {
        setLanguagesList([]);
      }
    }
  }, [languageListRes]);

  return (
    <>
      <div className="section-detail-event preveiwbox">
        <h4 className="preview-title">{t("Preview")}</h4>
        <div className="event-detail-body">
          <div className="event-img">
            {values.banner ? (
              <img src={values.banner} className="img-fluid" alt="banner" />
            ) : (
              <img
                src="https://cdnstg.training.com/halifax/image/10543/2016513182-20241212.png"
                className="img-fluid"
                alt="banner"
              />
            )}
          </div>
          <div className="event-details">
            <div className="d-flex justify-content-between gap-2 ttile-cj">
              <div className="evntimg">
                {values.thumbnail ? (
                  <img src={values.thumbnail} className="img-fluid" alt="thumbnail" />
                ) : (
                  <img
                    src="https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png"
                    className="img-fluid"
                    alt="thumbnail"
                  />
                )}
              </div>

              <div className="headevent">
                {values?.workshopName || t("Masterclass Name")}
              </div>
            </div>
            <div className="timedate-box">
              {!_.isEmpty(sessionData) && sessionData?.sessionStartDateTime ? (
                <div className="timevalue">
                  {moment(sessionData.sessionStartDateTime, "YYYY-MM-DD HH:mm").format("hh:mm A")}
                </div>
              ) : (
                <div className="timevalue">--:--</div>
              )}

              <div className="venue-vlau">
                {!_.isEmpty(sessionData) ? (
                  <div className="dayval">
                    {sessionData?.sessionStartDate && moment(sessionData.sessionStartDate).format("dddd, Do MMM YYYY")}
                  </div>
                ) : (
                  <div className="dayval">{t("Start Date")}</div>
                )}

                <div className="venueval">{t("Virtual Interaction")}</div>
              </div>
            </div>
            <div className="trainer-box mb-4">
              <p className="mb-2">
                <strong>{t("timezone")}</strong>
              </p>
              <div className="d-flex align-items-center gap-2">
                <div className="tect-vx">
                  {
                    !_.isEmpty(sessionData) && sessionData.sessionTimezone ?
                      timezoneOptions.find(tz => tz.value == sessionData.sessionTimezone)?.label
                      : t("No Language Selected.")
                  }
                  {/* {currentLanguage
                    ? currentLanguage === "1"
                      ? "English"
                      : "French"
                    : "No Language Selected."} */}
                </div>
              </div>
            </div>
            <div className="trainer-box mb-4">
              <p className="mb-2">
                <strong>{t("Trainer")}(s)</strong>
              </p>
              <ul className="d-flex gap-2 tranerlist flex-column p-0">
                {!_.isEmpty(trainersList) && !_.isEmpty(values.trainerIds) ? (
                  values.trainerIds.map((id) => {
                    const trainer = trainersList.find(trainer => trainer.id === id)
                    return (
                      <>
                        <li className="d-flex gap-2 align-items-center" key={`trainer-${id}`}>
                          <div className="img-box-ecclipse">
                            {trainer?.profile ? (
                              <img
                                src={trainer?.profile}
                                alt=""
                                className="imgbx"
                              />
                            ) : (
                              <img
                                src="/images/profile_avatar.png"
                                alt=""
                                className="imgbx"
                              />
                            )}
                          </div>
                          <div className="tect-vx">
                            {trainer?.display_name}
                            {/* {trainer.id !== chips[chips.length - 1].id && ","} */}
                          </div>
                        </li>
                      </>
                    )
                  })
                ) : (
                  <span className="">{t("Currently no trainers added")}</span>
                )}
              </ul>
            </div>
            <div className="trainer-box mb-4">
              <p className="mb-2">
                <strong>{t("language")}</strong>
              </p>
              <div className="d-flex align-items-center gap-2">
                <div className="tect-vx">
                  {
                    !_.isEmpty(sessionData) && sessionData.sessionLanguage ?
                    languageOptions.find(lan => lan.value == sessionData.sessionLanguage)?.label
                      : t("No Language Selected.")
                  }
                  {/* {currentLanguage
                    ? currentLanguage === "1"
                      ? "English"
                      : "French"
                    : "No Language Selected."} */}
                </div>
              </div>
            </div>
            {sessionData.modeOfAttendance === 'online' ?
            <div className="trainer-box mb-4">
              <p className="mb-2">
                <strong>URL</strong>
              </p>
              <div className="d-flex gap-2 tranerlist flex-column p-0">
                {!_.isEmpty(sessionData) && sessionData?.sessionURL ? (
                  <li className="d-flex gap-2 align-items-center">
                    <div className="tect-vx">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="rgba(45,45,45,1)"><path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z"></path></svg>
                    <u className="text-primary">{sessionData.sessionURL}</u>
                    </div>
                  </li>
                ) : (
                  <div className="tect-vx">{t("URL link")}</div>
                  // sessionURL.map((url, index) => (
                  //   <li className="d-flex gap-2 align-items-center">
                  //     <div className="tect-vx" key={index}>
                  //       <u className="text-primary">{url}</u>
                  //     </div>
                  //   </li>
                  // ))
                )}
              </div>
            </div> : 
            <div className="trainer-box mb-4">
            <p className="mb-2">
              <strong>{t('address')}</strong>
            </p>
            <div className="d-flex gap-2 tranerlist flex-column p-0">
              {!_.isEmpty(sessionData) && sessionData?.sessionAddress ? (
                <li className="d-flex gap-2 align-items-center">
                  <div className="tect-vx">
                    {sessionData.sessionAddress}
                  </div>
                </li>
              ) : (
                <div className="tect-vx">-</div>
                // sessionURL.map((url, index) => (
                //   <li className="d-flex gap-2 align-items-center">
                //     <div className="tect-vx" key={index}>
                //       <u className="text-primary">{url}</u>
                //     </div>
                //   </li>
                // ))
              )}
            </div>
          </div>
            }
            {false && 
            <div className="trainer-box mb-4">
              <p className="mb-2">
                <strong>{t("Status")}</strong>
              </p>
              <div className="d-flex align-items-center gap-2">
                {/* {
                  status === "active" ?
                  <img src="/images/check.png" alt="Close" />
                  :
                  <img src="/images/Close.svg" alt="Close" />
                } */}
                <div className="tect-vx text-capitalize">{values.status}</div>
              </div>
            </div>}
            <div className="trainer-box mb-4 filesbox">
              <p className="mb-2">
                {/* <strong>Uploaded Documents</strong> */}
                <strong>{t("workshopPrerequisites")}</strong>
              </p>

              {
                !_.isEmpty(prerequisites) || (!_.isEmpty(values.urls) && values.urls[0]) ?
                  <>
                    {!_.isEmpty(prerequisites) && prerequisites.map((file) => {
                      return (
                        <div
                          className="d-flex flex-column gap-2 mb-3 mt-3"
                          key={file.name}
                        >
                          <div className="uplod-ciox">
                            {file.name.includes(".pdf") && (
                              <img src="/images/pdf_1.svg" />
                            )}
                            {(file.name.includes(".docx") ||
                              file.name.includes(".doc")) && (
                                <img src="/images/docx_1.svg" />
                              )}
                            {(file.name.includes(".pptx") ||
                              file.name.includes(".ppt")) && (
                                <img src="/images/pptx_1.svg" />
                              )}
                            {(file.name.includes(".xlsx") ||
                              file.name.includes(".xls")) && (
                                <img src="/images/xlsx_1.svg" />
                              )}
                          </div>
                          <div className="tect-vx">{file.name}</div>
                        </div>
                      )
                    })}
                    {values.urls.map((url, index) => (
                      <li className="d-flex gap-2 align-items-center mb-2">
                        <div className="tect-vx">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="rgba(45,45,45,1)"><path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z"></path></svg>
                          <u className="text-primary"> {url}</u>
                        </div>
                      </li>
                    ))}
                  </>
                  : (
                    <span className="">{t("No files or url yet")}</span>
                  )}
            </div>
            <div className="trainer-box mb-4 filesbox">
              <p className="mb-2">
                {/* <strong>Uploaded Documents</strong> */}
                <strong>{t('workshopResources')}</strong>
              </p>
              {!_.isEmpty(resource) ? (
                [...resource].map((file) => (
                  <div
                    className="d-flex flex-column gap-2 mb-3"
                    key={file.name}
                  >
                    <div className="uplod-ciox">
                      {file.name.includes(".pdf") && (
                        <img src="/images/pdf_1.svg" />
                      )}
                      {(file.name.includes(".docx") ||
                        file.name.includes(".doc")) && (
                          <img src="/images/docx_1.svg" />
                        )}
                      {(file.name.includes(".pptx") ||
                        file.name.includes(".ppt")) && (
                          <img src="/images/pptx_1.svg" />
                        )}
                      {(file.name.includes(".xlsx") ||
                        file.name.includes(".xls")) && (
                          <img src="/images/xlsx_1.svg" />
                        )}
                    </div>
                    <div className="tect-vx">{file.name}</div>
                  </div>
                ))
              ) : (
                <span className="">{t("No files yet")}</span>
              )}
            </div>
            <div className="trainer-box mb-4">
              <p className="mb-2">
                <strong>{t("End user")}(s)</strong>
              </p>
              <div className="d-flex gap-2 tranerlist flex-column p-0">
                {
                  !_.isEmpty(membersList) &&
                    !_.isEmpty(values.participantIds) ?
                    values.participantIds.map((id) => {
                      const member = membersList.find(member => member.id === id)
                      return (
                        <li className="d-flex gap-2 align-items-center">
                          <div className="img-box-ecclipse">
                            {member?.profile_image ? (
                              <img
                                src={member?.profile_image}
                                alt={member?.first_name}
                              />
                            ) : (
                              <img
                                src="/images/profile_avatar.png"
                                alt={member?.first_name}
                              />
                            )}
                          </div>
                          <div className="tect-vx">
                            {member?.first_name} {member?.middle_name} {member?.last_name}
                          </div>
                        </li>
                      )
                    })
                    :
                    <span className="">{t("Currently no participant added")}</span>
                }
              </div>
            </div>

            <div className="trainer-box mb-4">
              <p className="mb-2">
                {/* <strong>Workshop Activities</strong></div> */}
                <strong>{t("Masterclass activities")}</strong>
              </p>
              {values.description ? (
                <>
                  <span className="prev-description"
                    dangerouslySetInnerHTML={{ __html: values.description }}
                  ></span>
                  {/* {values.description.length > 100 && <span>...</span>} */}
                </>
              ) : (
                <span className="">{t("Nothing yet")}</span>
              )}
            </div>
            <div className="d-flex gap-2 flex-wrap filepwrap">
              {/* {!_.isEmpty(resource) ? (
                resource.map((file) => (
                  <div className="d-flex flex-column gap-3 align-items-center">
                    <div className="uplod-ciox">
                    {file.name.includes(".pdf") && (
                        <img src="./images/pdf_1.svg"/>
                      )}

                       {((file.name.includes(".docx")) || (file.name.includes(".doc"))) && (
                        <img src="./images/docx_1.svg"/>
                      )}

                        {((file.name.includes(".pptx")) || (file.name.includes(".ppt"))) && (
                        <img src="./images/pptx_1.svg"/>
                      
                      )}

                      {((file.name.includes(".xlsx")) || (file.name.includes(".xls"))) && 
                      <img src="./images/xlsx_1.svg.svg"/>
                      }
                    </div>
                    <div className="tect-vx">{file.name}</div>
                  </div>
                ))
              ) : (
                <span className="">No files yet</span>
              )} */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupPreviewWorkshop;
